import { render, staticRenderFns } from "./CmgOrderConfirmationDeliveryInfo.vue?vue&type=template&id=05a97b05&scoped=true&lang=pug&"
import script from "./cmg-order-confirmation-delivery-info.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-confirmation-delivery-info.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderConfirmationDeliveryInfo.vue?vue&type=style&index=0&id=05a97b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a97b05",
  null
  
)

export default component.exports